type Props = {
  mapSizeW: string;
  mapSizeH: string;
};

export const GoogleMapComp: React.FC<Props> = (props) => {
  const googleMap_ = `
        <div class="mapouter">
            <div class="gmap_canvas">
                <iframe class="gmap_iframe" width="100%" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?width=${props.mapSizeW}&amp;height=${props.mapSizeH}&amp;hl=en&amp;q=Anel İş Merkezi Yamanevler Mah. Site Yolu Cad. No:5/6 34768 Ümraniye/ İstanbul&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed">
                </iframe>
            </div>
            <style>.mapouter{position:relative;text-align:right;width:100%;height:${props.mapSizeH}px;}.gmap_canvas {overflow:hidden;background:none!important;width:100%;height:${props.mapSizeW}px;}.gmap_iframe {height:${props.mapSizeH}px!important;}</style>
        </div>`;
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: googleMap_,
      }}
      data-testid="googleMap"
    />
  );
};
